import React from 'react';
import { CustomPageWidget } from '../../pages/custom-page/sections';

export const IframeTemplate = React.memo(({ page, widgets }) => {
  const { widget } = page;

  return <CustomPageWidget widgets={widgets} {...widget} />;
});
